import React, { Fragment } from 'react'
import { connect } from 'react-redux'

import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { setToken } from './features/auth/authSlice'
import Authentication from './components/Pages/Authentication'
// import Layout from './components/Pages/Layout'
// import Load from './components/Pages/Load'
// import AppInfo from './components/Pages/AppInfo'
import jwt_decode from 'jwt-decode'
// import GetStarted from './components/Pages/GetStarted'
import Header from './components/layout/Header/Header'
// import Footer from './components/layout/Footer/Footer'
// import Summary from './components/Pages/Summary'
import Conversations from './components/layout/Sidebar/Conversations'
import Loginscreen from './components/layout/Sidebar/Loginscreen'

const App = ({ authToken, setToken }) => {
  const validateToken = () => {
    if (authToken) {
      return true
    } else {
      const token = localStorage.getItem('token')
      const tokenData = token ? jwt_decode(token) : false
      if (tokenData && new Date(tokenData.exp * 1000) > new Date()) {
        if (
          tokenData.hasOwnProperty('ID') &&
          tokenData.hasOwnProperty('RoleID')
        ) {
          setToken({ authToken: token })
          return true
        } else {
          localStorage.clear()
          return false
        }
      } else {
        localStorage.clear()
        return false
      }
    }
  }
  const userLoggedIn = validateToken()
  // console.log(userLoggedIn)

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {!userLoggedIn && (
            <Fragment>
              {/* <Route path="*" element={<LoginLogoutFormView />} /> */}

              {/* <Route path="*" element={<Auth />} /> */}
              <Route path="*" element={<LoginScreenView />} />
              <Route path="/dashboard" element={<ConversationsView />} />
              <Route path="/Conversations" element={<ConversationsView />} />
              {/* <Route path="getStarted" element={<GetStartedView />} /> */}
              {/* <Route path="getStartedLogin" element={<GetStartedLoginView />} /> */}
            </Fragment>
          )}
          {userLoggedIn && (
            <Fragment>
              <Route path="*" element={<ConversationsView />} />
              <Route path="/dashboard" element={<ConversationsView />} />
              <Route path="/Conversations" element={<ConversationsView />} />
              {/* <Route path="/" element={<AboutApp />} />
            <Route path="getStarted" element={<GetStartedView />} />
            <Route path="appinfo" element={<AboutApp />} />
            <Route path="load" element={<SelectWebsiteList />} />
            <Route path="summary" element={<SummaryView />} />
            <Route path="*" element={<Auth />} /> */}
            </Fragment>
          )}
        </Routes>
      </BrowserRouter>
    </div>
  )
}

function Auth() {
  return (
    <div className="App pt-5">
      <Authentication></Authentication>
    </div>
  )
}

function ConversationsView() {
  return (
    <div className="App">
      <div className="row mx-0 px-0">
        <div className="col-12 col-md-12 col-lg-12">
          <Header />
          <Conversations />
        </div>
      </div>
    </div>
  )
}
function LoginScreenView() {
  return <Loginscreen />
}

const mapStateToProps = ({ auth }) => {
  const { authToken } = auth

  return {
    authToken
  }
}

const mapDispatchToProps = {
  setToken
}

export default connect(mapStateToProps, mapDispatchToProps)(App)
